import { useEffect, useState } from "react";
import BuildQRCode from "../BuildQRCode";
import identityHeaderLogo from "../../assets/logo2.png";
// Temporary fallback until the requested src/assets/icon.png is supplied.
import qrCenterIconFallback from "../../assets/mybuildid_qr_logo_black_red_transparent.png";
import { createTintedLogoDataUrl } from "../../utils/tintTransparentImage";
import { getMirrorScannableQrColor, getQrSafeColor, getResolvedBaseTheme, getScannableQrColor } from "../../utils/identityStudio";
import PaddockIdentityCard from "./PaddockIdentityCard";
import PaddockMirrorTag from "./PaddockMirrorTag";
import PaddockSticker from "./PaddockSticker";

function IdentityStudioPreview({ mode, settings, buildUrl, vehicleTitle, vehicleYear, vehicleMakeModel, stickerShape = "standard", mirrorProductPreview = true }) {
  const tintedHeaderLogo = useTintedImage(identityHeaderLogo, settings.accentColor);
  const tintedCenterIcon = useTintedImage(qrCenterIconFallback, settings.accentColor);
  const previewSettings = { ...settings, baseTheme: getResolvedBaseTheme(settings, mode) };
  const qrColor = mode === "mirror" ? getMirrorScannableQrColor(settings.accentColor) : ["card", "sticker"].includes(mode) ? getQrSafeColor(settings.accentColor) : getScannableQrColor(settings.accentColor);
  const qr = (
    <div className="identity-qr">
      <BuildQRCode url={buildUrl} logoSrc={settings.centerLogo === "mbid" ? tintedCenterIcon : undefined} size={640} theme={{ backgroundColor: "#ffffff", dotColor: qrColor, cornerSquareColor: mode === "mirror" ? qrColor : "#111111", cornerDotColor: qrColor, margin: 24, dotType: settings.qrDotStyle, cornerSquareType: settings.qrCornerSquareStyle, cornerDotType: settings.qrCornerDotStyle }} />
    </div>
  );

  if (mode === "qr") return <div className="identity-qr-only" aria-label={`QR code for ${vehicleTitle}`}>{qr}</div>;
  if (mode === "card") return <PaddockIdentityCard settings={previewSettings} headerLogo={tintedHeaderLogo} qr={qr} vehicleTitle={vehicleTitle} />;
  if (mode === "mirror") return <PaddockMirrorTag settings={previewSettings} headerLogo={tintedHeaderLogo} qr={qr} vehicleYear={vehicleYear} vehicleMakeModel={vehicleMakeModel} showProductOverlay={mirrorProductPreview} />;
  if (mode === "sticker") return <PaddockSticker settings={previewSettings} headerLogo={tintedHeaderLogo} qr={qr} vehicleTitle={vehicleTitle} shape={stickerShape} />;
  return null;
}

function useTintedImage(source, accentColor) {
  const [tintedSource, setTintedSource] = useState(source);
  useEffect(() => {
    let active = true;
    createTintedLogoDataUrl(source, accentColor)
      .then((result) => { if (active) setTintedSource(result); })
      .catch((error) => console.error("Identity logo tint failed:", error));
    return () => { active = false; };
  }, [source, accentColor]);
  return tintedSource;
}

export default IdentityStudioPreview;
